import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasBath = createSelector(selectJsonQuery, jsonQuery => getTermValue('bath')(jsonQuery));
